module["exports"] = [
  "#{Name.name}",
  "#{Company.name}"
];
